import { createAction, props } from '@ngrx/store';

import { Review } from '@shared/models/review';
import { Advantage, DigitalCourse, DigitalCourseFilter, DigitalCourseQueryParams, Question } from '../models';

export enum DigitalCourseActions {
  FetchDigitalCourses = '[Api/Course] Fetch Digital Courses',
  FetchDigitalCourse = '[Api/Course] Fetch Digital Course',
  FetchCourseAdvantage = '[Api/Course] Fetch Course Advantage',
  FetchCourseQuestion = '[Api/Course] Fetch Course Frequently Asked Questions',
  SaveCourseReview = '"[Api] Save Course Review"',

  AddDigitalCourses = '[DigitalCourse] Add Digital Courses',
  AddDigitalCourse = '[DigitalCourse] Add Digital Course',
  AddCourseAdvantage = '[DigitalCourse] Add Course Advantage',
  AddCourseQuestion = '[DigitalCourse] Add Course Frequently Asked Questions',
  AddSelectedCourse = '[DigitalCourse] Add Selected Digital Course Id',
  RemoveSelectedDigitalCourse = '[DigitalCourse] Remove Selected Digital Course Id',
  AddTotalCount = '[DigitalCourse] Add Digital Course Total Count',
  AddCourseReview = '[DigitalCourse] Add Course review',
  AddError = '[DigitalCourse] Add Digital Course Error',
}

// Effects Actions
export const FetchDigitalCourses = createAction(
  DigitalCourseActions.FetchDigitalCourses,
  props<{ queryParams: DigitalCourseQueryParams; filter?: DigitalCourseFilter }>()
);
export const FetchDigitalCourse = createAction(DigitalCourseActions.FetchDigitalCourse, props<{ courseId: string }>());
export const SaveCourseReview = createAction(
  DigitalCourseActions.SaveCourseReview,
  props<{ courseId: string; review: Review }>()
);
export const FetchCourseAdvantage = createAction(
  DigitalCourseActions.FetchCourseAdvantage,
  props<{ courseId: string }>()
);
export const FetchCourseQuestion = createAction(
  DigitalCourseActions.FetchCourseQuestion,
  props<{ courseId: string }>()
);

// Store Actions
export const AddDigitalCourses = createAction(
  DigitalCourseActions.AddDigitalCourses,
  props<{ courses: DigitalCourse[] }>()
);
export const AddDigitalCourse = createAction(DigitalCourseActions.AddDigitalCourse, props<{ course: DigitalCourse }>());
export const AddSelectedDigitalCourse = createAction(
  DigitalCourseActions.AddSelectedCourse,
  props<{ digitalCourseId: string }>()
);
export const AddCourseAdvantage = createAction(
  DigitalCourseActions.AddCourseAdvantage,
  props<{ advantages: Advantage[] }>()
);
export const AddCourseQuestion = createAction(
  DigitalCourseActions.AddCourseQuestion,
  props<{ questions: Question[] }>()
);
export const RemoveSelectedDigitalCourse = createAction(DigitalCourseActions.RemoveSelectedDigitalCourse);

export const AddTotalCount = createAction(DigitalCourseActions.AddTotalCount, props<{ totalCount: number }>());
export const AddCourseReview = createAction(DigitalCourseActions.AddCourseReview, props<{ review: Review }>());
export const AddError = createAction(DigitalCourseActions.AddError, props<{ error: any }>());
